import { getUrlParam } from '@tencent/vft-common/util';
import { getVuid } from '@tencent/vft-common/login';
export default {
  vuid: getVuid(),
  ptag: getUrlParam('ptag')
};